import React, { useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import { I18n } from 'react-redux-i18n'

import TimerSelectorUI from './TimerSelectorUI'

const TIME_OPTIONS = [
  { value: 'seconds', label: 'dashboard_seconds' },
  { value: 'minutes', label: 'dashboard_minutes' },
  { value: 'hours', label: 'dashboard_hours' },
  { value: 'days', label: 'dashboard_days' },
  { value: 'months', label: 'dashboard_months' }
]

const getTimeOptions = (includes = [], excludes = []) => {
  if (Array.isArray(excludes) && excludes?.length) {
    return TIME_OPTIONS.filter(el => !excludes.includes(el.value))
      .map(el => {
        el.label = I18n.t(el.label)

        return el
      })
  }

  if (Array.isArray(includes) && includes?.length) {
    return TIME_OPTIONS.filter(el => includes.includes(el.value))
      .map(el => {
        el.label = I18n.t(el.label)

        return el
      })
  }

  return TIME_OPTIONS.map(el => {
    el.label = I18n.t(el.label)

    return el
  })
}

const TimerSelector = (props) => {
  const {
    className, label, value, onChange, exclude, includes,
    onClickSave, disabled = false
  } = props

  const unitOptions = useMemo(
    () => {
      return getTimeOptions(includes, exclude)
    },
    [includes, exclude]
  )

  const [state, setState] = useState({})

  /**
   * @param {{unit: string, time: number}} data
   */
  const onChangeTime = (data) => {
    if (isNaN(data.time)) return
    const time = parseInt(data.time || 0, 10)

    if (value?.time === time) return

    const newState = { time: time, unit: data.unit }
    setState(newState)

    onChange(newState)
  }

  /**
   * @param {{unit: string, time: number}} data
   */
  const onChangeUnitTime = (data) => {
    if (!data.unit) return
    if (value?.unit === data.unit) return

    const newState = { time: data.time, unit: data.unit }
    setState(newState)

    onChange(newState)
  }

  return (
    <TimerSelectorUI
      className={className}
      label={label}
      unitOptions={unitOptions}
      time={state.time ?? value?.time}
      unit={state.unit ?? value?.unit}
      onChangeTime={onChangeTime}
      onChangeUnitTime={onChangeUnitTime}
      onClick={onClickSave}
      disabled={disabled}
    />
  )
}

TimerSelector.defaultProps = {
  className: '',
  label: '',
  value: null,
  onChange: null,
  exclude: [],
  includes: [],
  disabled: false,
  onClickSave: null
}

TimerSelector.propTypes  = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  exclude: PropTypes.array,
  includes: PropTypes.array,
  disabled: PropTypes.bool,
  onClickSave: PropTypes.func
}

export default TimerSelector
